var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",staticStyle:{"text-align":"center","background-color":"#1f2c3d"}},[_c('img',{attrs:{"src":'./images/404.jpg',"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }